import * as S from './styles';
//icons
import { CalendarDots, CaretDown, Export } from '@phosphor-icons/react';
export default function TitleDash() {
    return (
        <S.Container>
            <S.Title>
                <S.H4>Dashboard</S.H4>
                <S.H6>Gerencie os dados do sistema</S.H6>
            </S.Title>

            <S.ContentFilter>
                <S.Button>
                    <CalendarDots size={24} />
                    <S.H6>24 Setem., 2025</S.H6>
                    <CaretDown size={24} />
                </S.Button>
                <S.Button>
                    <Export size={24} />
                    <S.H6>Exportar</S.H6>
                </S.Button>
            </S.ContentFilter>
        </S.Container>
    )
}